import useShareImage, { ShareState } from './useShareImage'
export { ShareState }
export default useShareImage
